/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Templates_Refresh_Aria_LabelInputs */

const en_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh templates`)
};

const fr_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualiser les modeles`)
};

const de_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlagen aktualisieren`)
};

const it_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna i modelli`)
};

const ru_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновить шаблоны`)
};

const es_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualizar plantillas`)
};

const zh_cn2_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`刷新模板`)
};

const ja_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートを更新する`)
};

const hi_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेम्प्लेट रीफ़्रेश करें`)
};

const pt_pt2_event_templates_refresh_aria_label = /** @type {(inputs: Event_Templates_Refresh_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualizar modelos`)
};

/**
* | output |
* | --- |
* | "Refresh templates" |
*
* @param {Event_Templates_Refresh_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_templates_refresh_aria_label = /** @type {((inputs?: Event_Templates_Refresh_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Templates_Refresh_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_templates_refresh_aria_label(inputs)
	if (locale === "de") return de_event_templates_refresh_aria_label(inputs)
	if (locale === "it") return it_event_templates_refresh_aria_label(inputs)
	if (locale === "ru") return ru_event_templates_refresh_aria_label(inputs)
	if (locale === "es") return es_event_templates_refresh_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_templates_refresh_aria_label(inputs)
	if (locale === "ja") return ja_event_templates_refresh_aria_label(inputs)
	if (locale === "hi") return hi_event_templates_refresh_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_templates_refresh_aria_label(inputs)
	return en_event_templates_refresh_aria_label(inputs)
});